type OperatingSystem = 'windows' | 'mac' | 'unknown';

function getOS(): OperatingSystem {
  const userAgent = window.navigator.userAgent.toLowerCase();
  let os: OperatingSystem = 'unknown';

  if (userAgent.includes('win')) {
    os = 'windows';
  } else if (userAgent.includes('mac') || userAgent.includes('darwin')) {
    os = 'mac';
  }

  return os;
}

export default getOS;
